import $ from 'jquery'
$(function () {
	// 링크용 함수
	// ex)   <div data-href="http://google.com">
	// ex)   <div data-href="todayStudy.htm">
	// ex)   <div data-href="todayStudy.htm, window_name"> // 새창
	// ex)   <div data-href="todayStudy.htm, _blank"> // 새창
	// $("body").on("click", "[data-href]", function () {
    $("div .body").on("click", "[data-href]", function () {
		var href = $(this).attr("data-href");
		if (!href) return;
		href = href.split(",").map(function (item) { return item.trim(); });
		if (href.length > 1) {
			window.open(href[0], href[1]);
		} else {
			// location.href = href[0];
		}
	});

	$(window).on("scroll", function () {
		var top = $(this).scrollTop();
		if (top > 100) {
			$("header").addClass("ong");
		} else {
			$("header").removeClass("ong");
		}
	});

	$("header .icon_menu").on("click", function () {
		$("header nav, header .icon_menu").toggleClass("on");
	});

	$("header nav a").on("click", function () {
		$("header nav").removeClass("on");
	});
});

const CLIENT = function(){

    //rendering engines
    var engine = {            
        ie: 0,
        gecko: 0,
        webkit: 0,
        khtml: 0,
        opera: 0,

        //complete version
        ver: null  
    };

    //browsers
    var browser = {

        //browsers
        ie: 0,
		edge: 0,
        firefox: 0,
        safari: 0,
        konq: 0,
        opera: 0,
        chrome: 0,

        //specific version
        ver: null
    };


    //platform/device/OS
    var system = {
        win: false,
        mac: false,
        x11: false,

        //mobile devices
        iphone: false,
        ipod: false,
		ipad: false,
		android: false,
        nokiaN: false,
        winMobile: false,

        //game systems
        wii: false,
        ps: false 
    };    

    //detect rendering engines/browsers
    var ua = navigator.userAgent;    
    if (window.opera){
        engine.ver = browser.ver = window.opera.version();
        engine.opera = browser.opera = parseFloat(engine.ver);
    } else if (/AppleWebKit\/(\S+)/.test(ua)){
        const webkitMatch = ua.match(/AppleWebKit\/(\S+)/);
        engine.ver = webkitMatch[1];
        engine.webkit = parseFloat(engine.ver);

        //figure out if it's Chrome or Safari or Edge
        if (/Edge\/(\S+)/.test(ua)){
            const edgeMatch = ua.match(/Edge\/(\S+)/);
            browser.ver = edgeMatch[1];
            browser.ie = parseFloat(browser.ver);
        } else if (/Edg\/(\S+)/.test(ua)){
            const edgMatch = ua.match(/Edg\/(\S+)/);
            browser.ver = edgMatch[1];
            browser.edge = parseFloat(browser.ver);
        } else if (/Chrome\/(\S+)/.test(ua)){
            const chromeMatch = ua.match(/Chrome\/(\S+)/);
            browser.ver = chromeMatch[1];
            browser.chrome = parseFloat(browser.ver);
        } else if (/Version\/(\S+)/.test(ua)){
            const versionMatch = ua.match(/Version\/(\S+)/);
            browser.ver = versionMatch[1];
            browser.safari = parseFloat(browser.ver);
        }
        // 사용하지 않는 구간 주석
        // else {
        //     //approximate version
        //     var safariVersion = 1;
        //     if (engine.webkit < 100){
        //         safariVersion = 1;
        //     } else if (engine.webkit < 312){
        //         safariVersion = 1.2;
        //     } else if (engine.webkit < 412){
        //         safariVersion = 1.3;
        //     } else {
        //         safariVersion = 2;
        //     }   
        // }
    } else if (/KHTML\/(\S+)/.test(ua) || /Konqueror\/([^;]+)/.test(ua)){
        const khtmlMatch = ua.match(/KHTML\/(\S+)/) || ua.match(/Konqueror\/([^;]+)/);
        engine.ver = browser.ver = khtmlMatch[1];
        engine.khtml = browser.konq = parseFloat(engine.ver);
    } else if (/rv:([^)]+)\) Gecko\/\d{8}/.test(ua)){    
        const geckoMatch = ua.match(/rv:([^)]+)\) Gecko\/\d{8}/);
        engine.ver = geckoMatch[1];
        engine.gecko = parseFloat(engine.ver);

        //determine if it's Firefox
        if (/Firefox\/(\S+)/.test(ua)){
            const firefoxMatch = ua.match(/Firefox\/(\S+)/);
            browser.ver = firefoxMatch[1];
            browser.firefox = parseFloat(browser.ver);
        }
    } else if (/MSIE ([^;]+)/.test(ua)){
        const msieMatch = ua.match(/MSIE ([^;]+)/);
        engine.ver = browser.ver = msieMatch[1];
        engine.ie = browser.ie = parseFloat(engine.ver);
    } else if (/Trident\/(\S+)/.test(ua)){	    
    	engine.ver = browser.ver = "11";
    	engine.ie = browser.ie = 11;
    }

    //detect browsers
   //browser.ie = engine.ie;
    browser.opera = engine.opera;


    //detect platform
    var p = navigator.platform;
    system.win = p.indexOf("Win") === 0;
    system.mac = p.indexOf("Mac") === 0;
    system.x11 = (p === "X11") || (p.indexOf("Linux") === 0);

    //detect windows operating systems
    if (system.win){
        const winMatch = ua.match(/Win(?:dows )?([^do]{2})\s?(\d+\.\d+)?/);
        if (winMatch) {
            if (winMatch[1] === "NT"){
                switch(winMatch[2]){
                    case "5.0":
                        system.win = "2000";
                        break;
                    case "5.1":
                        system.win = "XP";
                        break;
                    case "6.0":
                        system.win = "Vista";
                        break;
                    case "6.1":
                        system.win = "Win7";
                        break;
                    case "6.3":
                        system.win = "Win8";
                        break;
                    case "10.0":
                        system.win = "Win10";
                        break;
                    default:
                        system.win = "NT";
                        break;                
                }                            
            } else if (winMatch[1] === "9x"){
                system.win = "ME";
            } else {
                system.win = winMatch[1];
            }
        }
    }

    //mobile devices
    system.android = ua.indexOf("Android") > -1;
    system.iphone = ua.indexOf("iPhone") > -1;
    system.ipod = ua.indexOf("iPod") > -1;
    system.ipad = ua.indexOf("iPad") > -1;
    system.nokiaN = ua.indexOf("NokiaN") > -1;
    system.winMobile = (system.win === "CE");

    //gaming systems
    system.wii = ua.indexOf("Wii") > -1;
    system.ps = /playstation/i.test(ua);

    //return it
    return {
        engine:     engine,
        browser:    browser,
        system:     system        
    };

}();

// CLIENT를 전역 변수로 선언 : window.CLIENT로 사용가능
window.CLIENT = CLIENT;

// CLIENT를 모듈로 export : 다른 파일에서 import 가능
export default CLIENT;

/**
 * 이벤트 위임(Event Delegation)을 위한 유틸리티 함수
 * @param {string} type - 이벤트 타입 (예: 'click', 'mouseover', 'submit' 등)
 * @param {string} selector - CSS 선택자 (예: '.button', '#submit', 'div[data-href]' 등)
 * @param {Function} callback - 이벤트 발생 시 실행할 콜백 함수
 * 
 * 사용 예시:
 * addGlobalListener('click', '[data-href]', function(e) {
 *     const href = e.target.getAttribute('data-href');
 *     if (href) {
 *         window.location.href = href;
 *     }
 * });
 */
/*
function addGlobalListener(type, selector, callback) {
	document.addEventListener(type, function (e) {
		if (e.target.matches(selector)) callback(e);
	}, {
		bubble: true
	});
}
*/

// scroll end 이벤트 바인딩
$.fn.scrollEnd = function (callback, timeout) {
	timeout = timeout || 200;
	$(this).scroll(function () {
		var $this = $(this);
		if ($this.data('scrollTimeout')) {
			clearTimeout($this.data('scrollTimeout'));
		}
		$this.data('scrollTimeout', setTimeout(function () {
			callback($this);
		}, timeout));
	});
};

// 비사용 함수로 인하여 주석처리 ----------------------------------------
// function isMobile(){
// 	var UserAgent = navigator.userAgent;
// 	if (UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null) {
// 		return true;
// 	} else {
// 		return false;
// 	}
// }

// function isMobileAndTablet () {
// 	let check = false;
// 	(function(a){
// 		if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;
// 	})(navigator.userAgent||navigator.vendor||window.opera);
// 	return check;
// }

// function emptyCache () {
// 	$.ajax({
//         url: "",
//         context: document.body,
//         success: function(s, x){
//             $('html[manifest=saveappoffline.appcache]').attr('content', '');
//                 $(this).html(s);
//         }
//     });
// }
// 비사용 함수로 인하여 주석처리 ----------------------------------------

// 이전 브라우저 지원을 위한 코드이지만 lint 오류 발생아래 비활성화 추가
/* eslint-disable no-extend-native */
if (!Array.prototype.forEach) {
	Array.prototype.forEach = function (fn, scope) {
		for (var i = 0, len = this.length; i < len; i++) {
			fn.call(scope || this, this[i], i, this);
		}
	}
}

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

if (window.HTMLCollection && !HTMLCollection.prototype.forEach) {
	HTMLCollection.prototype.forEach = Array.prototype.forEach;
}